import { defineStore } from "pinia";
import { getServices, getDelegues, getObjets } from "@/api/auth";

export const useContactsStore = defineStore("contact", {
  state: () => ({
    services: [],
    objets: [],
    delegues: [],
    loading: false,
    error: null,
  }),
  getters: {
    Services: state => state.services,
    Objets: state => state.objets,
    Delegues: state => state.delegues ?? [],
  },
  actions: {
    async fetchServices_Delegues() {
      this.loading = true;
      try {
        const [deleguesRes, servicesRes] = await Promise.all([getDelegues(), getServices()]);

        this.delegues = deleguesRes.data;
        this.services = servicesRes.data;
        this.loading = false;
      } catch {
        this.error = "Erreur lors du chargement des services";
      }
    },
    async fetchObjets() {
      this.loading = true;
      try {
        const response = await getObjets();
        this.objets = response.data;
        this.loading = false;
      } catch {
        this.error = "Erreur lors du chargement des objets";
      }
    },
  },
});
